import { useParams } from 'react-router-dom';

type PathwayUrl = {
  pathwayId: string;
};

const usePathwayId = () => {
  const params = useParams<PathwayUrl>();
  return Number(params.pathwayId);
};

export { usePathwayId };
